import { useTranslation } from "react-i18next";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { apiRequest } from "@/lib/queryClient";

export function LanguageSwitcher() {
    const { t, i18n } = useTranslation();

    const changeLanguage = async (value: string) => {
        i18n.changeLanguage(value);
        try {
            await apiRequest("PATCH", "/api/auth/language", { language: value });
        } catch (error) {
            console.error("Failed to update language desire backend:", error);
        }
    };

    return (
        <div className="flex items-center space-x-2">
            <Select value={i18n.language?.split('-')[0]} onValueChange={changeLanguage}>
                <SelectTrigger className="w-[180px]">
                    <SelectValue placeholder={t('profile.selectLanguage')} />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="en">English</SelectItem>
                    <SelectItem value="fr">Français</SelectItem>
                    <SelectItem value="es">Español</SelectItem>
                </SelectContent>
            </Select>
        </div>
    );
}

